<template>
  <pages-list />
</template>

<script>
import PagesList from './../components/PagesList'

export default {
  name: 'PagesIndex',
  components: {
    PagesList
  }
}
</script>
